import useLocalize from '../../../utils/hooks/useLocalize';
import SectionHeaderComponent from '../SectionHeaderComponent';
import './SummarySection.scss';

const CreditInfoSection = () => {
  const localize = useLocalize();
  const title = localize('symbol.details.credit.info.section.title');
  return (
    <div className="summary-section">
      <SectionHeaderComponent title={title} />
      <div className="summary-section-content">
        {/* Credit info content will be added in future stories */}
      </div>
    </div>
  );
};

export default CreditInfoSection;
